/**
 * Created by cahyo on 20/02/19
 */

import AppConfig from './AppConfig';

export default class Notification {

  public static showNotification(params: any, error: boolean = false) {
    try {
      const vm: any = AppConfig.getVm();

      if (vm && vm.$notify !== undefined && params) {
        const status: any = params.status ? params.status : '0000';
        let {text, duration, group, type, title} = params;

        text = text ? text : vm.$t('notification.' + status);
        duration = duration || 3000;
        group = group || 'default';
        type = error ? 'error' : (type || 'success');
        title = title || vm.$t('label.info');

        vm.$notify({text, duration, group, type, title});
      }
    } catch (e) {
      console.log(e.toString());
    }
  }
}
